import { ProtectedRoute, TranslationBreadcrumb } from "components/UI";
import { DetailTracking, Tracking } from "./pages";

const trackingRoutes = [
  {
    path: "/location-tracking",
    element: (
      <ProtectedRoute name="location_tracking">
        <Tracking />
      </ProtectedRoute>
    ),
    breadcrumb: () => (
      <TranslationBreadcrumb
        name="location_tracking"
        defaultTitle="tracking.title"
      />
    ),
  },
  {
    path: "/location-tracking/detail/:id",
    element: (
      <ProtectedRoute name="location_tracking">
        <DetailTracking />
      </ProtectedRoute>
    ),
    breadcrumb: () => <TranslationBreadcrumb name="tracking.detail_tracking" />,
  },
];

export default trackingRoutes;
